<div class="no-access">
  <h2>No admin access</h2>
  <p>You don't have admin access. If you reached this page by mistake, you can close this tab.</p>
</div>
